export default __webpack_public_path__ + "static/media/100_38803.47d0af04.jpg";